import { useMount } from 'ahooks';
import { useAppDispatch } from 'app/hooks';
import { RevxSkeleton } from 'components';
import { MultiTypeEnum, SKU } from 'domains/skuDomain';
import { FileItem } from 'domains/workspaceDetailDomain';
import { JobItem } from 'domains/workspaceDomain';
import 'features/JobConfig/ConfigStep/Step10AddFiles.less';
import { useJobStatusCollection } from 'hooks/useJobStatusCollection';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import workspaceService from 'services/jobService';
import skuService from 'services/skuService';
import { CommonFilesSubmit, CommonUploadFile } from '../../common';
import { useDefaultFileList } from '../../common/UploadFile/useDefaultFileList';
import useShowUploadFileFlag from 'features/Workspace/hooks/useShowUploadFileFlag';
import './ProxyFiles.less';

const ProxyFiles = (jobData: JobItem) => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  // const uiStatusFilter = useAppSelector(
  //   (state) => state.workspace.uiStatusFilter
  // );
  const [fileList, setFileList] = useState<FileItem[]>();
  const [defaultFileList, setDefaultFileList] = useState<FileItem[]>();
  const [isConfirm, setArtworkConfirm] = useState<boolean>(
    jobData.artworkConfirm
  );
  const statusFilters = useJobStatusCollection();
  const [loading, setLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [sku, setSku] = useState<SKU>();
  const isWrapperSku = sku?.multiType === MultiTypeEnum.WRAPPER;

  const showUploadAction = useShowUploadFileFlag(jobData);

  const getSkuDefaultFileList = useDefaultFileList(defaultFileList || []);

  useMount(async () => {
    setLoading(true);
    dispatch.workspace.getJobItemCount(jobData.id);
    const fileListRes = await dispatch.workspaceDetail.getAllFile(jobData);
    setFileList(fileListRes);
    setDefaultFileList(fileListRes);
    setArtworkConfirm(jobData.artworkConfirm);
    const skuDetail = await skuService.startViewSku(
      {
        id: jobData.skuId,
      },
      true
    );
    setSku(skuDetail);
    setLoading(false);
  });

  const fileSubmit = async () => {
    dispatch.app.showLoading();
    try {
      await dispatch.workspaceDetail.fileSubmit(jobData);
      const jobItem = await workspaceService.getJobDetail(jobData.id);
      setArtworkConfirm(jobItem.artworkConfirm);
      dispatch.workspace.getJobCountByStatusFilter(statusFilters);
      dispatch.workspace.getJobItemCount(jobData.id);
      dispatch.workspace.reloadJobList();
    } catch (e) {}
    dispatch.app.hideLoading();
  };

  const onUploadFileChange = async () => {
    const fileListRes = await dispatch.workspaceDetail.getAllFile(jobData);
    setFileList(fileListRes);
    setDefaultFileList(fileListRes);
  };

  return (
    <div className="proxy-files-card">
      <RevxSkeleton loading={loading}>
        <header>
          <p>{t('workspace.detail.files.attachFiles')}</p>
          <span hidden={isConfirm}>
            {t('workspace.detail.files.attachFilesTip')}:
          </span>
        </header>

        {isWrapperSku ? (
          <div>
            {(sku?.parts || []).map((partSku) => {
              return (
                <div className="add-files-section">
                  <div className="add-files-item-title">
                    {partSku.part.name}
                  </div>
                  <div style={{ paddingLeft: 20 }}>
                    <CommonUploadFile
                      showUploadButton={showUploadAction}
                      defaultFileList={getSkuDefaultFileList(partSku.part.id)}
                      itemData={jobData}
                      deleteFileHandler={dispatch.workspaceDetail.deleteFile}
                      getAllFileHandler={dispatch.workspaceDetail.getAllFile}
                      saveFileHandler={async (item) => {
                        const fileItem =
                          await dispatch.workspaceDetail.saveFile({
                            ...item,
                            skuId: partSku.part.id,
                          });
                        return fileItem;
                      }}
                      onUploadFileChange={onUploadFileChange}
                      setIsUploading={setIsUploading}
                    />
                  </div>
                </div>
              );
            })}
            <div className="add-files-section">
              <div className="add-files-item-title">Other Files</div>
              <div style={{ paddingLeft: 20 }}>
                <CommonUploadFile
                  showUploadButton={showUploadAction}
                  defaultFileList={getSkuDefaultFileList()}
                  itemData={jobData}
                  deleteFileHandler={dispatch.workspaceDetail.deleteFile}
                  getAllFileHandler={dispatch.workspaceDetail.getAllFile}
                  saveFileHandler={dispatch.workspaceDetail.saveFile}
                  onUploadFileChange={onUploadFileChange}
                  setIsUploading={setIsUploading}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="add-files-section">
            <CommonUploadFile
              showUploadButton={showUploadAction}
              defaultFileList={defaultFileList}
              itemData={jobData}
              deleteFileHandler={dispatch.workspaceDetail.deleteFile}
              getAllFileHandler={dispatch.workspaceDetail.getAllFile}
              saveFileHandler={dispatch.workspaceDetail.saveFile}
              onUploadFileChange={onUploadFileChange}
              setIsUploading={setIsUploading}
            />
          </div>
        )}

        {showUploadAction && !isConfirm && (
          <CommonFilesSubmit
            text={t('workspace.detail.files.submitFiles')}
            disabled={!fileList?.length || isUploading}
            onClick={() => fileSubmit()}
          />
        )}
      </RevxSkeleton>
    </div>
  );
};

export default ProxyFiles;
